import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import BackButton from "@/components/BackButton";
import ChampionshipsPanel from "@/components/admin/ChampionshipsPanel";
import { Flag, Info, Clock } from "lucide-react";

export default function Organizer() {
  const { user, loading, isAuthenticated, isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) navigate("/accedi");
  }, [loading, isAuthenticated, navigate]);

  if (loading || user === null) {
    return <div className="max-w-7xl mx-auto px-6 py-20 text-zinc-500">Caricamento…</div>;
  }
  if (!isAuthenticated) return null;

  const blocked = !isAdmin && user.rejected;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
      <BackButton className="mb-6" />
      <div className="flex items-center gap-3 mb-6">
        <Flag className="h-8 w-8 text-yellow-400 text-glow-yellow" />
        <div>
          <h1 className="font-heading text-3xl sm:text-4xl font-black uppercase tracking-tighter text-zinc-50">
            Campionati Tuoi
          </h1>
          <p className="text-sm text-zinc-500">Ciao {user.name}, gestisci i tuoi campionati</p>
        </div>
      </div>

      {blocked ? (
        <div className="flex items-start gap-3 border border-red-500/30 bg-red-500/5 p-6" data-testid="blocked-account-notice">
          <Clock className="h-6 w-6 text-red-400 shrink-0 mt-0.5" />
          <div>
            <h3 className="font-heading text-lg font-bold text-zinc-50">Account sospeso</h3>
            <p className="text-sm text-zinc-300 mt-1">
              Il tuo account è stato sospeso dall'amministratore. Contatta l'organizzazione per maggiori informazioni.
            </p>
          </div>
        </div>
      ) : (
        <>
          <div className="flex items-start gap-3 border border-cyan-500/30 bg-cyan-500/5 p-4 mb-8" data-testid="approval-notice">
            <Info className="h-5 w-5 text-cyan-400 shrink-0 mt-0.5" />
            <p className="text-sm text-zinc-300">
              Crea il tuo campionato con il pulsante <span className="text-yellow-400 font-bold">Nuovo</span>. Ogni campionato e ogni modifica devono essere
              <span className="text-cyan-400 font-bold"> approvati dall'amministratore</span> prima di diventare pubblici. Dopo ogni modifica il campionato torna in stato <span className="text-yellow-400 font-bold">in attesa</span>.
            </p>
          </div>
          <ChampionshipsPanel endpoint="/championships/mine" showStatus createKind="community" />
        </>
      )}
    </div>
  );
}
